import React from "react";
import ProductGroupSettingsPage from "../../../components/List/ProductGroupSettingsList"
import { useTranslation } from "react-i18next";

const EditProductGroupsPage: React.FC = () => {
    const { t } = useTranslation();
    return (
        <ProductGroupSettingsPage
            title={t("common.productGroup")}
            fetchUrl= "/itemApi/GetProductGroupList"
            createOrUpdateUrl="itemApi/CreateOrUpdateProductGroup"
            deleteUrl="itemApi/DeleteProductGroup"
        
        />
    );
};

export default EditProductGroupsPage;
